import { StoreHeader } from "../components/StoreHeader";
import { Leadership } from "../components/Leadership";
import { Footer } from "../components/Footer";

export default function LeadershipPage() {
  return (
    <div className="bg-[#070707] text-[#F5F5F0] min-h-screen" data-testid="leadership-page">
      <StoreHeader />
      <main className="pt-20">
        <Leadership />
      </main>
      <Footer />
    </div>
  );
}
